import { defineComponent, ref, watch } from "vue";
import { definePropType } from "@types-vue/props";
export default defineComponent({
    props: {
        isCollapse: {
            type: Boolean,
            default: false
        },
        toggleClick: {
            type: definePropType(Function),
            default: null
        }
    },
    setup: function setup(props) {
        var isActive = ref(false);
        watch(function() {
            return props.isCollapse;
        }, function(val) {
            if (val) {
                isActive.value = val;
            } else {
                setTimeout(function() {
                    isActive.value = val;
                }, 300);
            }
        });
        return {
            isActive: isActive
        };
    }
});
